// webTracking.js — analytics propio (first-party) de la tienda/panel.
// Registra un 'pageview' en cada carga/ruta y un 'ping' de presencia cada 30s.
// Anónimo: session_id random en sessionStorage, sin PII. Escribe vía RPC web_track (anon).
// El canal (instagram/facebook/google/whatsapp/directo/utm) lo deriva el server desde referer + UTM.
import { supabase } from './supabase'

const SID_KEY = 'limpack_sid'
let sid = null
let beat = null
let started = false

function getSid() {
  if (sid) return sid
  try { sid = sessionStorage.getItem(SID_KEY) } catch { /* */ }
  if (!sid) {
    sid = 'w' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10)
    try { sessionStorage.setItem(SID_KEY, sid) } catch { /* */ }
  }
  return sid
}

function utm(k) {
  try { return new URLSearchParams(window.location.search).get(k) } catch { return null }
}

// Link de aliado: ?ref=BIKO → utm_source=BIKO, utm_medium=referral.
// Solo si no vino un utm_source explícito (que gana siempre para no pisar campañas reales).
function refSlug() {
  try {
    const r = new URLSearchParams(window.location.search).get('ref')
    return r ? r.trim().toUpperCase() : null
  } catch { return null }
}

async function send(tipo) {
  try {
    const ref = refSlug()
    const utmSrc = utm('utm_source') || ref
    const utmMed = utm('utm_medium') || (ref ? 'referral' : null)
    await supabase.rpc('web_track', {
      p_sid: getSid(),
      p_tipo: tipo,
      p_host: window.location.hostname,
      p_path: window.location.pathname,
      p_ref: document.referrer || '',
      p_utm_source: utmSrc,
      p_utm_medium: utmMed,
      p_utm_campaign: utm('utm_campaign'),
    })
  } catch { /* silencioso — nunca romper la UI por analytics */ }
}

/** Registrar una vista de página (llamar en cada cambio de ruta). */
export function trackPageview() { send('pageview') }

/** Arrancar el latido de presencia (una sola vez). */
export function startHeartbeat() {
  if (started) return
  started = true
  beat = setInterval(() => { if (document.visibilityState === 'visible') send('ping') }, 30000)
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') send('ping') })
}
